module.exports = __webpack_public_path__ + "images/emoji/pig_nose.635537e0fbbb8c98ac4c.png";